// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"styles_tableHeadCell__orxiH","tableBodyCell":"styles_tableBodyCell__tfJix"};